import { HttpContextToken } from '@angular/common/http';

/**
 * Offline GET cache opt-outs for `offlineQueueInterceptor`.
 *
 * We use HttpContext (not headers) to avoid leaking client-side behavior
 * to backends and to keep requests debuggable without server changes.
 */
export const SKIP_OFFLINE_GET_CACHE_WRITE = new HttpContextToken<boolean>(() => false);
export const SKIP_OFFLINE_GET_CACHE_FALLBACK = new HttpContextToken<boolean>(() => false);

